/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * logicomix-api
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  CreateAttributesApiDTO,
  DeleteApiPrepaymentsId200,
  GetApiPrepayments200Item,
  GetApiPrepaymentsId200,
  GetApiPrepaymentsIdRegenerationImpact200,
  GetApiPrepaymentsIdRegenerationImpactParams,
  GetApiPrepaymentsParams,
  PatchApiPrepaymentsId200,
  PostApiPrepayments200,
  UpdatePrepaymentAttributesApiDTO
} from './Api.schemas'
import { customInstance } from '../AxiosInstance';
import type { ErrorType } from '../AxiosInstance';




export const postApiPrepayments = (
    createAttributesApiDTO: CreateAttributesApiDTO,
 ) => {
      
      
      return customInstance<PostApiPrepayments200>(
      {url: `/api/prepayments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createAttributesApiDTO
    },
      );
    }
  


export const getPostApiPrepaymentsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiPrepayments>>, TError,{data: CreateAttributesApiDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postApiPrepayments>>, TError,{data: CreateAttributesApiDTO}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postApiPrepayments>>, {data: CreateAttributesApiDTO}> = (props) => {
          const {data} = props ?? {};

          return  postApiPrepayments(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostApiPrepaymentsMutationResult = NonNullable<Awaited<ReturnType<typeof postApiPrepayments>>>
    export type PostApiPrepaymentsMutationBody = CreateAttributesApiDTO
    export type PostApiPrepaymentsMutationError = ErrorType<unknown>

    export const usePostApiPrepayments = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postApiPrepayments>>, TError,{data: CreateAttributesApiDTO}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof postApiPrepayments>>,
        TError,
        {data: CreateAttributesApiDTO},
        TContext
      > => {

      const mutationOptions = getPostApiPrepaymentsMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getApiPrepayments = (
    params?: GetApiPrepaymentsParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetApiPrepayments200Item[]>(
      {url: `/api/prepayments`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetApiPrepaymentsQueryKey = (params?: GetApiPrepaymentsParams,) => {
    return [`/api/prepayments`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiPrepaymentsQueryOptions = <TData = Awaited<ReturnType<typeof getApiPrepayments>>, TError = ErrorType<unknown>>(params?: GetApiPrepaymentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiPrepayments>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPrepaymentsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPrepayments>>> = ({ signal }) => getApiPrepayments(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiPrepayments>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiPrepaymentsQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPrepayments>>>
export type GetApiPrepaymentsQueryError = ErrorType<unknown>

export const useGetApiPrepayments = <TData = Awaited<ReturnType<typeof getApiPrepayments>>, TError = ErrorType<unknown>>(
 params?: GetApiPrepaymentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiPrepayments>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiPrepaymentsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



/**
 * Statements that editing or deleting this prepayment would regenerate, oldest first, to be
confirmed before the change. For an edit, pass the amountInEuros and recognitionPeriod about to
be submitted: the list is empty when neither differs from the stored values, exactly as the PATCH
would then schedule nothing. Without them, the impact is that of a deletion.
 */
export const getApiPrepaymentsIdRegenerationImpact = (
    id: string,
    params?: GetApiPrepaymentsIdRegenerationImpactParams,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetApiPrepaymentsIdRegenerationImpact200>(
      {url: `/api/prepayments/${id}/regeneration-impact`, method: 'GET',
        params, signal
    },
      );
    }
  

export const getGetApiPrepaymentsIdRegenerationImpactQueryKey = (id: string,
    params?: GetApiPrepaymentsIdRegenerationImpactParams,) => {
    return [`/api/prepayments/${id}/regeneration-impact`, ...(params ? [params]: [])] as const;
    }

    
export const getGetApiPrepaymentsIdRegenerationImpactQueryOptions = <TData = Awaited<ReturnType<typeof getApiPrepaymentsIdRegenerationImpact>>, TError = ErrorType<unknown>>(id: string,
    params?: GetApiPrepaymentsIdRegenerationImpactParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiPrepaymentsIdRegenerationImpact>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPrepaymentsIdRegenerationImpactQueryKey(id,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPrepaymentsIdRegenerationImpact>>> = ({ signal }) => getApiPrepaymentsIdRegenerationImpact(id,params, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiPrepaymentsIdRegenerationImpact>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiPrepaymentsIdRegenerationImpactQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPrepaymentsIdRegenerationImpact>>>
export type GetApiPrepaymentsIdRegenerationImpactQueryError = ErrorType<unknown>

export const useGetApiPrepaymentsIdRegenerationImpact = <TData = Awaited<ReturnType<typeof getApiPrepaymentsIdRegenerationImpact>>, TError = ErrorType<unknown>>(
 id: string,
    params?: GetApiPrepaymentsIdRegenerationImpactParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiPrepaymentsIdRegenerationImpact>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiPrepaymentsIdRegenerationImpactQueryOptions(id,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const patchApiPrepaymentsId = (
    id: string,
    updatePrepaymentAttributesApiDTO: UpdatePrepaymentAttributesApiDTO,
 ) => {
      
      
      return customInstance<PatchApiPrepaymentsId200>(
      {url: `/api/prepayments/${id}`, method: 'PATCH',
      headers: {'Content-Type': 'application/json', },
      data: updatePrepaymentAttributesApiDTO
    },
      );
    }
  


export const getPatchApiPrepaymentsIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiPrepaymentsId>>, TError,{id: string;data: UpdatePrepaymentAttributesApiDTO}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof patchApiPrepaymentsId>>, TError,{id: string;data: UpdatePrepaymentAttributesApiDTO}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof patchApiPrepaymentsId>>, {id: string;data: UpdatePrepaymentAttributesApiDTO}> = (props) => {
          const {id,data} = props ?? {};

          return  patchApiPrepaymentsId(id,data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PatchApiPrepaymentsIdMutationResult = NonNullable<Awaited<ReturnType<typeof patchApiPrepaymentsId>>>
    export type PatchApiPrepaymentsIdMutationBody = UpdatePrepaymentAttributesApiDTO
    export type PatchApiPrepaymentsIdMutationError = ErrorType<unknown>

    export const usePatchApiPrepaymentsId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof patchApiPrepaymentsId>>, TError,{id: string;data: UpdatePrepaymentAttributesApiDTO}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof patchApiPrepaymentsId>>,
        TError,
        {id: string;data: UpdatePrepaymentAttributesApiDTO},
        TContext
      > => {

      const mutationOptions = getPatchApiPrepaymentsIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const deleteApiPrepaymentsId = (
    id: string,
 ) => {
      
      
      return customInstance<DeleteApiPrepaymentsId200>(
      {url: `/api/prepayments/${id}`, method: 'DELETE'
    },
      );
    }
  


export const getDeleteApiPrepaymentsIdMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiPrepaymentsId>>, TError,{id: string}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof deleteApiPrepaymentsId>>, TError,{id: string}, TContext> => {
const {mutation: mutationOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteApiPrepaymentsId>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteApiPrepaymentsId(id,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteApiPrepaymentsIdMutationResult = NonNullable<Awaited<ReturnType<typeof deleteApiPrepaymentsId>>>
    
    export type DeleteApiPrepaymentsIdMutationError = ErrorType<unknown>

    export const useDeleteApiPrepaymentsId = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteApiPrepaymentsId>>, TError,{id: string}, TContext>, }
): UseMutationResult<
        Awaited<ReturnType<typeof deleteApiPrepaymentsId>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteApiPrepaymentsIdMutationOptions(options);

      return useMutation(mutationOptions);
    }
    export const getApiPrepaymentsId = (
    id: string,
 signal?: AbortSignal
) => {
      
      
      return customInstance<GetApiPrepaymentsId200>(
      {url: `/api/prepayments/${id}`, method: 'GET', signal
    },
      );
    }
  

export const getGetApiPrepaymentsIdQueryKey = (id: string,) => {
    return [`/api/prepayments/${id}`] as const;
    }

    
export const getGetApiPrepaymentsIdQueryOptions = <TData = Awaited<ReturnType<typeof getApiPrepaymentsId>>, TError = ErrorType<unknown>>(id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiPrepaymentsId>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiPrepaymentsIdQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiPrepaymentsId>>> = ({ signal }) => getApiPrepaymentsId(id, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiPrepaymentsId>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiPrepaymentsIdQueryResult = NonNullable<Awaited<ReturnType<typeof getApiPrepaymentsId>>>
export type GetApiPrepaymentsIdQueryError = ErrorType<unknown>

export const useGetApiPrepaymentsId = <TData = Awaited<ReturnType<typeof getApiPrepaymentsId>>, TError = ErrorType<unknown>>(
 id: string, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiPrepaymentsId>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiPrepaymentsIdQueryOptions(id,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



